module.exports = {
  api: 'https://preprod.api.euresto.com/',
  socketTransport: ["polling", "websocket"],
}





// WEBPACK FOOTER //
// ./public/config/project.config.js